export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11105.0ec700eb.jpg";